import React from "react";
import Swal from "sweetalert2";
import axios from "axios";

function ContenedoresActivos({ id }) {

  const activosAlert = async () => {

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/get_cont_act?final_master_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.error === false) {
        Swal.fire({
          title: "Guardado",
          text: "Los datos han sido guardados correctamente.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }

    Swal.fire({
      title: "Editar Contenedores",
      html: `
        <div class="container">
          <div class="row">

            <div class="col-md-6 mb-3">
              <h5>Contenedores activos</h5>
              <div class="mb-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <input class="form-check-input me-2" type="checkbox" id="contRKN">
                    <label class="form-check-label me-2" for="contRKN">RKN</label>
                  </div>
                  <input type="number" class="form-control ms-2 w-50" id="inputRKN" placeholder="Cantidad" disabled />
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <input class="form-check-input me-2" type="checkbox" id="contRAP">
                    <label class="form-check-label me-2" for="contRAP">RAP</label>
                  </div>
                  <input type="number" class="form-control ms-2 w-50" id="inputRAP" placeholder="Cantidad" disabled />
                </div>
              </div>
            </div>
  
            <div class="col-md-6 mb-3">
              <h5>Preparación de contenedor</h5>
              <div class="mb-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <input class="form-check-input me-2" type="checkbox" id="prepRKN">
                    <label class="form-check-label me-2" for="prepRKN">RKN</label>
                  </div>
                  <input type="number" class="form-control ms-2 w-50" id="inputPrepRKN" placeholder="Cantidad" disabled />
                </div>
              </div>
              <div class="mb-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <input class="form-check-input me-2" type="checkbox" id="prepRAP">
                    <label class="form-check-label me-2" for="prepRAP">RAP</label>
                  </div>
                  <input type="number" class="form-control ms-2 w-50" id="inputPrepRAP" placeholder="Cantidad" disabled />
                </div>
              </div>
            </div>
          </div>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "custom-modal-width",
      },
      didOpen: () => {
        const pairs = [
          { checkboxId: "contRKN", inputId: "inputRKN", group: "A" },
          { checkboxId: "contRAP", inputId: "inputRAP", group: "A" },
          { checkboxId: "prepRKN", inputId: "inputPrepRKN", group: "B" },
          { checkboxId: "prepRAP", inputId: "inputPrepRAP", group: "B" },
        ];

        const getElement = (id) => document.getElementById(id);

        const handleGroupToggle = (changedCheckboxId, group) => {
          pairs.forEach(({ checkboxId, inputId, group: pairGroup }) => {
            const checkbox = getElement(checkboxId);
            const input = getElement(inputId);

            if (checkboxId === changedCheckboxId) {
              input.disabled = !checkbox.checked;
              if (!checkbox.checked) input.value = "";
            } else if (pairGroup !== group) {
              checkbox.checked = false;
              input.value = "";
              input.disabled = true;
            } else {
              input.disabled = !checkbox.checked;
              if (!checkbox.checked) input.value = "";
            }
          });
        };

        pairs.forEach(({ checkboxId, group }) => {
          const checkbox = getElement(checkboxId);
          checkbox.addEventListener("change", () => handleGroupToggle(checkboxId, group));
        });
      },
    }).then(async (result) => {
      if (result.isConfirmed) {

        var cRKN = document.getElementById("contRKN").checked ? 1 : null;
        var cNoRKN = document.getElementById("inputRKN").value;

        var cRAP = document.getElementById("contRAP").checked ? 1 : null;
        var cNoRAP = document.getElementById("inputRAP").value;

        var pRKN = document.getElementById("prepRKN").checked ? 1 : null;
        var pNoRKN = document.getElementById("inputPrepRKN").value;

        var pRAP = document.getElementById("prepRAP").checked ? 1 : null;
        var pNoRAP = document.getElementById("inputPrepRAP").value;

        var params = {
          master: id,
          cRKN: cRKN,
          cNoRKN: cNoRKN,
          cRAP: cRAP,
          cNoRAP: cNoRAP,
          pRKN: pRKN,
          pNoRKN: pNoRKN,
          pRAP: pRAP,
          pNoRAP: pNoRAP
        };

        try {
          const response = await axios.post(
            `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/ajax_update_cont_act`,
            params,
            {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
              },
            }
          );

          if (response.data.error === false) {
            Swal.fire({
              title: "Guardado",
              text: "Los datos han sido guardados correctamente.",
              icon: "success",
              iconColor: "#1B9925",
              customClass: {
                confirmButton: "btn-ok",
                title: "alert-title",
                popup: "alert-bg",
              },
            });
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error", "error");
        }
      }
    });
  };

  return (
    <button className="btnn" onClick={activosAlert}>
      Cont. Activos
    </button>
  );
}

export default ContenedoresActivos;
